import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppService } from "../../../core/services/app.service";

@Injectable({
    providedIn: 'root'
})
export class ExploreService {
    public geoTagPhotosAPI = AppService.getApiUrl() + '/api/photos/getGeoTagPhotos';

    constructor(private http: HttpClient) {}

    public getGeoTagPhotos() {
        // Get photo with filter
        // const filter = encodeURIComponent(JSON.stringify({
        //     where: {
        //         and: [
        //             {location: {neq: null}},
        //             {location: {neq: 'Unknown'}}
        //         ]
        //     }
        // }));
        // return this.http.get(`${this.geoTagPhotosAPI}?filter=${filter}`);
        return this.http.get(`${this.geoTagPhotosAPI}?filter={}`);
    }
}
